import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { VioTablesV2Component } from 'vio-tables-v2';
import type { VT2_TABLE_CONFIG } from 'vio-tables-v2';
import { ApiRequestsService } from '../../services/api-requests.service';

@Component({
  selector: 'app-upload-history',
  standalone: true,
  imports: [CommonModule, VioTablesV2Component],
  templateUrl: './upload-history.component.html',
  styleUrl: './upload-history.component.scss',
})
export class UploadHistoryComponent implements OnInit, OnDestroy {
  isAdmin = false;
  private userSub?: Subscription;

  uploadHistory: any[] = [];
  isLoadingUploadHistory = false;
  uploadHistoryErrorMessage = '';

  uploadHistoryTableConfig: VT2_TABLE_CONFIG = {
    tableTitle: 'Upload History',
    excelFileName: 'pdf-upload-history',
    columnLabels: {
      fileName: 'File Name',
      fileuploadtype: 'Document Type',
      payslipMonth: 'Payslip Month',
      payslipYear: 'Payslip Year',
      insertedCount: 'Inserted',
      skippedCount: 'Skipped',
      uploadedByName: 'Uploaded By',
      uploadDate: 'Uploaded On',
      name: 'Employee Name',
      payslipFor: 'Payslip For',
      empNo: 'Employee No.',
      reason: 'Reason',
    },
    excludeFields: ['_id', 'skipped'],
    dateFields: ['uploadDate'],
    isSortable: true,
    showFormulaButton: false,
    showSummationButton: false,
    showHeaderGroupButton: false,
    hyperlinkFields: {
      skippedCount: {
        popupTitle: (value, row) => `Skipped Entries — ${row.fileName}`,
        onClick: (value, row) => (row.skipped && row.skipped.length ? row.skipped : undefined),
      },
    },
  };

  constructor(private apiService: ApiRequestsService) {}

  ngOnInit(): void {
    this.userSub = this.apiService.currentUser?.subscribe((user) => {
      const wasAdmin = this.isAdmin;
      this.isAdmin = user?.role === 'admin';
      if (this.isAdmin && !wasAdmin) {
        this.loadUploadHistory();
      }
    });
  }

  ngOnDestroy(): void {
    this.userSub?.unsubscribe();
  }

  loadUploadHistory() {
    this.uploadHistoryErrorMessage = '';
    this.isLoadingUploadHistory = true;

    this.apiService.getApiCall('api/v1/pdfuploadedbyuser/list').subscribe({
      next: (res: any) => {
        this.isLoadingUploadHistory = false;
        if (res && res.errorCode === this.apiService.NO_ERROR) {
          this.uploadHistory = res.Data || [];
        } else {
          this.uploadHistoryErrorMessage = res?.errorDescription || 'Unable to load upload history.';
        }
      },
      error: () => {
        this.isLoadingUploadHistory = false;
        this.uploadHistoryErrorMessage = 'Unable to load upload history. Please check your connection.';
      },
    });
  }
}
